export type LocationLike =
  | string
  | {
      name?: string | null;
      country?: string | null;
      place_name?: string | null;
    }
  | null
  | undefined;

export function formatLocation(location: LocationLike): string {
  if (!location) return '';
  if (typeof location === 'string') return location;

  const name = location.name?.trim();
  const country = location.country?.trim();
  if (name && country) {
    return `${name}, ${country}`;
  }

  const placeName = location.place_name?.trim();
  if (placeName) {
    const parts = placeName.split(',').map((part) => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0]}, ${parts[parts.length - 1]}`;
    }
    return placeName;
  }

  return name || '';
}

